import { render, staticRenderFns } from "./AccountBookList.vue?vue&type=template&id=3e1378e8&scoped=true&xmlns%3Av-touch=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./AccountBookList.vue?vue&type=script&lang=js&"
export * from "./AccountBookList.vue?vue&type=script&lang=js&"
import style0 from "./AccountBookList.vue?vue&type=style&index=0&id=3e1378e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1378e8",
  null
  
)

export default component.exports